import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IChatFormFieldAction } from '@nimbus-global/features/chat-form/models/chat-form-resolver.model';
import { CompanionReferenceType, ICompanionReference } from '@nimbus-library/features/companion-chat/models/companion-conversation.model';
import { ChatFormTenantMode, ChatFormTenantResolver } from '@nimbus-global/features/chat-form/models/chat-form-tenant-resolver';
import { CompanionChatResolver as BaseCompanionChatResolver } from '@nimbus-library/features/companion-chat/services/companion-chat-resolver';
import { IChatFormEntityHandler } from '@nimbus-library/features/companion-chat/services/form-entity-handlers/i-chat-form-entity-handler';
import { VirtualUserService } from '@nimbus-global/features/manage/services/virtual-user.service';
import { GroupSelectionFormControlComponent } from '@nimbus-admin/features/organization-unit/components/group-selection-form-control/group-selection-form-control.component';
import { GroupSelectionLookupService } from '@nimbus-admin/features/organization-unit/services/group-selection-lookup.service';
import { TeamChatFormEntityHandler } from './form-entity-handlers/team-chat-form-entity-handler';
import { VirtualUserChatFormEntityHandler } from './form-entity-handlers/virtual-user-chat-form-entity-handler';

@Injectable()
export class CompanionChatResolver extends BaseCompanionChatResolver {
  public readonly formResolvers: IChatFormEntityHandler[];

  public constructor(
    private readonly teamHandler: TeamChatFormEntityHandler,
    private readonly virtualUserHandler: VirtualUserChatFormEntityHandler,
    private readonly groupSelectionLookupService: GroupSelectionLookupService,
    private readonly virtualUserService: VirtualUserService,
  ) {
    super();
    this.formResolvers = [this.teamHandler, this.virtualUserHandler];
  }

  public notifyEntityChanged(kind: CompanionReferenceType): void {
    if (kind === CompanionReferenceType.VirtualUser) {
      this.virtualUserService.notifyVirtualUsersChanged();
    }
  }

  public resolveReferenceLink(reference: ICompanionReference): Observable<IChatFormFieldAction> {
    switch (reference.kind) {
      case CompanionReferenceType.VirtualUser:
        return this.virtualUserHandler.resolveReferenceLink(reference);
      default:
        return of(null);
    }
  }

  public readonly resolveTenant: ChatFormTenantResolver = () => {
    const scope = this.groupSelectionLookupService.getTenantSelectionScope();
    if (!scope.isPartnerRequired && scope.tenantIds.length === 1) {
      return {
        mode: ChatFormTenantMode.Fixed,
        tenantId: scope.tenantIds[0],
        component: null,
      };
    }

    return {
      mode: ChatFormTenantMode.Selector,
      tenantId: null,
      component: GroupSelectionFormControlComponent,
    };
  };
}
